<template>
  <select
    v-model="localValue"
    :required="required"
    :name="name"
    :placeholder="placeholder"
    class="cac-select d-block">
    <option
      disabled
      selected
      value="">{{ placeholderText }}</option>
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"> {{ option.label }} </option>
  </select>
</template>

<script>
export default {
  name: "CACSelect",
  props: {
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    showPlaceholder: {
      type: Boolean,
      required: false,
      default: true
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    placeholderText() {
      return this.showPlaceholder
        ? this.$t("cac.app.please_select_one")
        : this.placeholder;
    }
  }
};
</script>
